import { useEffect } from "react";
import SelectdDropDown from "../../../../../components/DropDownComponent";
import DefaultModal from "../../JobApproval/component/dialog";
import { CreditAlertType } from "../model/creditAlertEnums";
import { setFormData, setToast } from "../viewmodel/creditAlerts.actions";
import Toast from "../../../../../components/Toast";
import { ConfirmDeleteModal } from "../../../../../components/ConfirmationPopUp";
import { XMarkIcon } from "@heroicons/react/24/outline";
import InputField from "../../../../../components/InputFieldForm";

export const CreateCreditAlert = ({
  open,
  onClose,
  state,
  dispatch,
  getCreditHistoryData,
}: {
  open: boolean;
  onClose: () => void;
  state: any;
  dispatch: any;
  getCreditHistoryData: any;
}) => {
  const CreditAlertTypeLabelMap: Record<CreditAlertType, string> = {
    [CreditAlertType.FIXED_AMOUNT]: "Fixed Amount",
    [CreditAlertType.PERCENTAGE]: "Percentage",
  };

  useEffect(() => {
    if (open) {
      dispatch(
        setFormData({
          alert_type: CreditAlertType.FIXED_AMOUNT,
          threshold_value: "",
          notify_admins: false,
        }),
      );
    }
  }, [open, dispatch]);
  const validateThreshold = (
    alertType: CreditAlertType,
    value: number | "",
  ) => {
    if (value === "" || value === null || value === undefined) {
      return "Threshold value is required";
    }

    if (alertType === CreditAlertType.FIXED_AMOUNT) {
      if (value > 9999) {
        return "Only 4 digit amount allowed";
      }
    }
    if (alertType === CreditAlertType.PERCENTAGE) {
      if (value > 100) {
        return "Percentage cannot exceed 100%";
      }
    }

    return "";
  };
  const handleClose = () => {
  dispatch({ type: "RESET_FORM_DATA" }); 
  onClose();
};
  return (
    <DefaultModal
      open={open}
      onClose={handleClose}
      className="w-full max-w-full sm:max-w-xl lg:max-w-2xl mx-2 sm:mx-auto"
    >
      <div className="flex flex-col  bg-white rounded-lg">
        <div className="flex items-center justify-between  px-6 py-2">
          <h3 className="text-lg font-medium text-gray-900">
            Create New Credit Alert
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-6 w-6"
             />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-2 space-y-4">
          <div>
            <SelectdDropDown
              id="alertType"
              label="Alert Type"
              required
              value={state?.formData?.alert_type}
              options={Object.values(CreditAlertType).map((type) => ({
                label: CreditAlertTypeLabelMap[type],
                value: type,
              }))}
              onChange={(value) => {
                dispatch(setFormData({ alert_type: value }));
              }}
              error={state?.validateErrors?.alert_type || ""}
            />
          </div>
          <div>
            <InputField
              label="Threshold Value"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              min={0}
              value={state.formData.threshold_value ?? ""}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "Escape",
                  "Enter",
                  "ArrowLeft",
                  "ArrowRight",
                  "Home",
                  "End",
                ];

                if (
                  allowedKeys.includes(e.key) ||
                  ((e.ctrlKey || e.metaKey) &&
                    ["a", "c", "v", "x"].includes(e.key.toLowerCase()))
                ) {
                  return;
                }

                if (!/^\d$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => {
                const pastedValue = e.clipboardData.getData("text");

                if (!/^\d*$/.test(pastedValue)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const value = e.target.value;

                if (!/^\d*$/.test(value)) {
                  return;
                }

                // ✅ Allow empty input
                if (value === "") {
                  dispatch(setFormData({ threshold_value: "" }));

                  dispatch({
                    type: "SET_VALIDATION_ERROR",
                    payload: {
                      field: "threshold_value",
                      message: "Threshold value is required",
                    },
                  });

                  return;
                }

                const numericValue = Number(value);

                if (
                  state.formData.alert_type === CreditAlertType.FIXED_AMOUNT &&
                  value.length > 4
                ) {
                  return;
                }

                const error = validateThreshold(
                  state.formData.alert_type,
                  numericValue,
                );

                dispatch(setFormData({ threshold_value: numericValue }));

                dispatch({
                  type: "SET_VALIDATION_ERROR",
                  payload: {
                    field: "threshold_value",
                    message: error,
                  },
                });
              }}
            />
            <span className="absolute right-3 top-2 text-gray-400">
              {state.formData.alert_type === CreditAlertType.PERCENTAGE
                ? "%"
                : "$"}
            </span>
            <p>
              {state?.validateErrors?.threshold_value && (
                <p className="text-red-500 text-xs mt-1">
                  {state.validateErrors.threshold_value}
                </p>
              )}
            </p>
          </div>
          <div className="p-2">
            <div className="flex items-center gap-2">
              <input
                id="default-flow"
                type="checkbox"
                checked={state.formData.notify_admins || false}
                onChange={(e) =>
                  dispatch(setFormData({ notify_admins: e.target.checked }))
                }
                className="w-4 h-4"
              />
              <label
                htmlFor="default-flow"
                className="text-sm font-medium text-gray-700"
              >
                Notify Admins
              </label>
            </div>
          </div>
        </div>
        <div className="flex justify-end p-4 mt-auto">
          <button
            onClick={getCreditHistoryData}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Create
          </button>
        </div>
      </div>
    </DefaultModal>
  );
};
